import { render, staticRenderFns } from "./dataQueryTemplate.vue?vue&type=template&id=8751a8c4&scoped=true"
import script from "./dataQueryTemplate.vue?vue&type=script&lang=js"
export * from "./dataQueryTemplate.vue?vue&type=script&lang=js"
import style0 from "./dataQueryTemplate.vue?vue&type=style&index=0&id=8751a8c4&prod&scoped=true&lang=css"
import style1 from "./dataQueryTemplate.vue?vue&type=style&index=1&id=8751a8c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751a8c4",
  null
  
)

export default component.exports